// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { HasFields } from "@insite/client-framework/Types/ContentItemModel";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import {
    DataTable,
    DataTableBody,
    DataTableCell,
    DataTableHead,
    DataTableHeader,
    DataTableRow,
} from "@insite/mobius/index";
import uniqueId from "@insite/mobius/utilities/uniqueId";
import React from "react";

const enum fields {
    columns = "columns",
    rows = "rows",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.columns]: { fields: { title: string } }[];
        [fields.rows]: { fields: { dataRows: { fields: { title: string } }[] } }[];
    };
}

type Props = WidgetProps & OwnProps;

const ContentTable = ({ fields }: Props) => {
    return (
        <DataTable>
            <DataTableHead>
                {fields.columns.map(col => (
                    <DataTableHeader key={uniqueId()}>{col.fields.title}</DataTableHeader>
                ))}
            </DataTableHead>
            <DataTableBody>
                {fields.rows.map(row => (
                    <DataTableRow key={uniqueId()}>
                        {row.fields.dataRows.map(dataRow => (
                            <DataTableCell key={uniqueId()}>{dataRow.fields.title}</DataTableCell>
                        ))}
                    </DataTableRow>
                ))}
            </DataTableBody>
        </DataTable>
    );
};

const widgetModule: WidgetModule = {
    component: ContentTable,
    definition: {
        displayName: "Content Table",
        group: "XNGAGE" as any,
        fieldDefinitions: [
            {
                name: fields.columns,
                editorTemplate: "ListField",
                defaultValue: [],
                getDisplay: (item: HasFields) => {
                    return item.fields.title;
                },
                fieldType: "General",
                fieldDefinitions: [
                    {
                        name: "title",
                        editorTemplate: "TextField",
                        defaultValue: "",
                        isRequired: true,
                    },
                ],
            },
            {
                name: fields.rows,
                editorTemplate: "ListField",
                defaultValue: [],
                getDisplay: (item: HasFields) => {
                    return item.fields.title;
                },
                fieldType: "General",
                fieldDefinitions: [
                    {
                        name: "dataRows",
                        editorTemplate: "ListField",
                        defaultValue: [],
                        getDisplay: (item: HasFields) => {
                            return item.fields.title;
                        },
                        fieldDefinitions: [
                            {
                                name: "title",
                                editorTemplate: "TextField",
                                defaultValue: "",
                                isRequired: true,
                            },
                        ],
                    },
                ],
            },
        ],
    },
};

export default widgetModule;
